module.exports = __webpack_public_path__ + "img/dialog_logout.a55c8f39.svg";